"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _GEHelper = require("../../graphicEngine/GEHelper");
var _GEDragHelper = require("../../graphicEngine/GEDragHelper");
var GL_VAR_POS = {
  VALUE_Y: -8.5,
  LABEL_Y: -8,
  STATUS_Y: 8
};
var STATUS = {
  READY: 0,
  LEARNING: 1,
  DONE: 2,
  NO_MODEL: 3
};
var LearningView = exports["default"] = /*#__PURE__*/function () {
  function LearningView() {
    var _this = this;
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'model name' : _ref$name,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? STATUS.NO_MODEL : _ref$status,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value;
    (0, _classCallCheck2["default"])(this, LearningView);
    this.id = Entry.generateHash();
    this.visible = true;
    this.value = value;
    var fontFamily = EntryStatic.fontFamily || "NanumGothic, 'Nanum Gothic'";
    this.BORDER = 6;
    this.FONT = "10pt ".concat(fontFamily);
    this.VALUE_FONT = "9pt ".concat(fontFamily);
    this.name = name;
    this.status = status;
    this.generateView();
    Entry.addEventListener('stop', function () {
      _this.view_.visible = true;
      _this.visible = true;
      _this.setValue(0);
    });
  }
  return (0, _createClass2["default"])(LearningView, [{
    key: "setX",
    value: function setX(x) {
      this.x_ = x;
      this.updateView();
    }
  }, {
    key: "getX",
    value: function getX() {
      return this.x_;
    }
  }, {
    key: "setY",
    value: function setY(y) {
      this.y_ = y;
      this.updateView();
    }
  }, {
    key: "getY",
    value: function getY() {
      return this.y_;
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return this.visible;
    }
  }, {
    key: "setVisible",
    value: function setVisible(visibleState) {
      this.view_.visible = visibleState;
      this.visible = visibleState;
      this.updateView();
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      this.value = value;
      if (value == 0) {
        this.status = STATUS.READY;
      } else if (value === 100) {
        this.status = STATUS.DONE;
      } else if (value < 100) {
        this.status = STATUS.LEARNING;
      }
      this.updateView();
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      Entry.stage.removeVariable(this);
    }
  }, {
    key: "setStatus",
    value: function setStatus(status) {
      this.status = status;
      this.updateView();
    }
  }, {
    key: "generateView",
    value: function generateView() {
      var variableIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.view_ = _GEHelper.GEHelper.newContainer();
      this.rect_ = _GEHelper.GEHelper.newGraphic();
      this.view_.addChild(this.rect_);
      this.view_.variable = this;
      this.view_.visible = this.visible;
      this.view_.mouseEnabled = true;
      _GEDragHelper.GEDragHelper.handleDrag(this.view_);
      this.wrapper_ = _GEHelper.GEHelper.newGraphic();
      this.view_.addChild(this.wrapper_);
      this.textView_ = _GEHelper.GEHelper.textHelper.newText(this.name, this.FONT, '#000000', 'alphabetic');
      this.textView_.x = 4;
      if (_GEHelper.GEHelper.isWebGL) {
        this.textView_.y = GL_VAR_POS.LABEL_Y;
      } else {
        this.textView_.y = 1;
      }
      this.view_.addChild(this.textView_);
      this.statusView = _GEHelper.GEHelper.textHelper.newText(Lang.AiLearning["model_status_".concat(this.status)], this.FONT, '#000000', 'alphabetic');
      this.statusView.x = 4;
      if (_GEHelper.GEHelper.isWebGL) {
        this.statusView.y = GL_VAR_POS.STATUS_Y;
      } else {
        this.statusView.y = 15;
      }
      this.view_.addChild(this.statusView);
      this.view_.on(_GEDragHelper.GEDragHelper.types.DOWN, function (evt) {
        if (Entry.type !== 'workspace') {
          return;
        }
        this.offset = {
          x: this.x - (evt.stageX * 0.75 - 240),
          y: this.y - (evt.stageY * 0.75 - 135)
        };
      });
      this.view_.on(_GEDragHelper.GEDragHelper.types.MOVE, function (evt) {
        if (Entry.type !== 'workspace') {
          return;
        }
        this.variable.setX(evt.stageX * 0.75 - 240 + this.offset.x);
        this.variable.setY(evt.stageY * 0.75 - 135 + this.offset.y);
        this.variable.updateView();
      });
      var width = this.textView_.getMeasuredWidth() + 26;
      width = Math.max(width, 90);
      this.maxWidth = width - 20;
      this.slideBar_ = _GEHelper.GEHelper.newGraphic();
      this.slideBar_.graphics.beginFill('#d8d8d8').s('#d8d8d8').ss(1).rr(6, 28, this.maxWidth, 5, 2);
      this.view_.addChild(this.slideBar_);
      var visibleValue = this.value / 100 * this.maxWidth;
      this.valueBar = _GEHelper.GEHelper.newGraphic();
      if (visibleValue > 0) {
        this.valueBar.graphics.beginFill('#4f80ff').s('#4f80ff').ss(1).rr(6, 28, visibleValue, 5, 2);
      }
      this.view_.addChild(this.valueBar);
      var variableLength = Entry.variableContainer.variables_.length;
      if (this.getX() && this.getY()) {
        this.setX(this.getX());
        this.setY(this.getY());
      } else {
        this.setX(10 - 240 + Math.floor(variableLength / 11) * 80);
        this.setY(variableIndex * 24 + 20 - 135 - Math.floor(variableLength / 11) * 264);
      }
      this.setVisible(this.isVisible());
      Entry.stage.loadVariable(this);
    }
  }, {
    key: "updateView",
    value: function updateView() {
      if (!this.view_) {
        return;
      }
      if (this.isVisible()) {
        this._adjustSingleViewPosition();
        var oldContent = this.textView_.text;
        var newContent = this.name;
        if (oldContent !== newContent) {
          this.textView_.text = newContent;
          this._nameWidth = null;
        }
        if (!this._nameWidth) {
          this._nameWidth = this.textView_.getMeasuredWidth();
        }
        var oldStatus = this.statusView.text;
        var newStatus = Lang.AiLearning["model_status_".concat(this.status)];
        if (oldStatus !== newStatus) {
          this.statusView.text = newStatus;
        }
        var width = this._nameWidth + 35;
        var colorSet = EntryStatic.colorSet.canvas || {};
        width = Math.max(width, 90);
        this.rect_.graphics.clear().f('#ffffff').ss(1, 2, 0).s(colorSet.border || '#aac5d5').rr(0, -14, width, 54, 4);
        width = this._nameWidth + 26;
        width = Math.max(width, 90);
        this.maxWidth = width - 16;
        var visibleValue = this.value / 100 * this.maxWidth;
        this.slideBar_.graphics.clear().beginFill('#d8d8d8').s('#d8d8d8').ss(1).rr(6, 28, this.maxWidth + 4, 5, 2);
        if (visibleValue > 0) {
          this.valueBar.graphics.clear().beginFill('#4f80ff').s('#4f80ff').ss(1).rr(6, 28, visibleValue, 5, 2);
        }
      }
      Entry.requestUpdate = true;
    }
  }, {
    key: "_adjustSingleViewPosition",
    value: function _adjustSingleViewPosition() {
      this.view_.x = this.getX();
      this.view_.y = this.getY();
    }
  }]);
}();